import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import type { Timestamp } from 'firebase/firestore';
import { db } from '@/backend/lib/firebase';

export interface PaymentSettings {
  iban: string;
  accountHolder: string;
  bankName: string;
  paymentInstructions: string;
  firstPaymentLabel: string;
  updatedAt?: Timestamp;
  updatedBy?: string;
}

export const DEFAULT_PAYMENT_SETTINGS: PaymentSettings = {
  iban: '',
  accountHolder: '',
  bankName: '',
  paymentInstructions: '',
  firstPaymentLabel: "First month's rent",
};

const SETTINGS_REF = () => doc(db, 'settings', 'payment');

export async function getPaymentSettings(): Promise<PaymentSettings> {
  const snap = await getDoc(SETTINGS_REF());
  if (!snap.exists()) return { ...DEFAULT_PAYMENT_SETTINGS };
  const data = snap.data() as Partial<PaymentSettings>;
  return {
    iban: data.iban ?? '',
    accountHolder: data.accountHolder ?? '',
    bankName: data.bankName ?? '',
    paymentInstructions: data.paymentInstructions ?? '',
    firstPaymentLabel: data.firstPaymentLabel?.trim()
      ? data.firstPaymentLabel
      : DEFAULT_PAYMENT_SETTINGS.firstPaymentLabel,
    updatedAt: data.updatedAt,
    updatedBy: data.updatedBy,
  };
}

export async function updatePaymentSettings(
  data: Partial<PaymentSettings>,
  updatedBy: string,
): Promise<void> {
  await setDoc(
    SETTINGS_REF(),
    { ...data, updatedAt: serverTimestamp(), updatedBy },
    { merge: true },
  );
}
